<!--
 * @Author: your name
 * @Date: 2020-11-17 10:19:24
 * @LastEditTime: 2020-11-17 13:44:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \avueData_web\src\components\test\index.vue
-->
<template>
  <div :style="{color:'#fff','width':optionsWidth, 'height':optionsHeight}">
    <!-- <h2>自定义组件</h2>
    <h3>我是参数:{{option.data}}</h3> -->
    <div id="lineCharts" style="width:100%; height:100%" ></div>
  </div>
</template>
<script>
let myChart = null
export default {
  name: 'test',
  props: {
    option: Object,
    component: Object
  },
  inject: ["main","contain"],
  data () {
    return {
      optionsWidth:400,
      optionsHeight:400,
      optionssss:{
          xAxis: {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
              type: 'value'
          },
          series: [{
              data: [820, 932, 901, 934, 1290, 1330, 1320],
              type: 'line'
          }]
      }
    }
  },
  computed: {
    fontSize () {
      return   '30px'
    },
    main (newVal) {
      console.log(newVal,'--xxx')
    },
    contain (newVal) {
      console.log('watch contain-')
    }
  },
  
  mounted () {
    this.init()
    console.log(this, '---option')
  },
  methods :{
    updateData () {
      // console.log(this, 'updateData')
      let data = this.main.activeObj.data
      const {width, height} = this.component

      this.optionssss.xAxis.data =  data.categories
      this.optionssss.series[0].data = data.series[0].data
      myChart.setOption(this.optionssss, true);
      console.log(width, this.optionsWidth)
      if ((width!== this.optionsWidth) || (height !== this.optionsHeight)) {
        this.optionsHeight = height
        this.optionsWidth = width
        myChart.clear();
        myChart.resize();
        myChart.setOption(this.optionssss, true);
      }
      
    },
    updateChart () {
      console.log('updateChart')
    },
    init () {
      myChart = echarts.init(document.getElementById('lineCharts'));
      let data = this.$attrs.data
      console.log(data,'==data')
      this.optionssss.xAxis.data =  data.categories
      this.optionssss.series[0].data = data.series[0].data
      myChart.setOption(this.optionssss, true);


    }
  }
}
</script>
<style scoped>
#lineCharts{width: 400px;height: 200px;;}
</style>